import React from 'react';
import { X, TrendingUp, CheckCircle2, AlertCircle, Target, Lightbulb } from 'lucide-react';
import Button from '../../../components/ui/Button';
import './AnalysisResultsModal.css';

const AnalysisResultsModal = ({ isOpen, onClose, analysis }) => {
  if (!isOpen || !analysis) return null;

  const getCategoryColor = (category) => {
    switch (category?.toLowerCase()) {
      case 'safety':
        return 'var(--success)';
      case 'target':
        return 'var(--warning)';
      case 'reach':
        return 'var(--danger)';
      default:
        return 'var(--muted-foreground)';
    }
  };

  const getCategoryLabel = (category) => {
    if (!category) return 'Reach';
    const normalized = category.toLowerCase();
    return normalized.charAt(0).toUpperCase() + normalized.slice(1);
  };

  return (
    <div className="analysis-results-overlay" onClick={onClose}>
      <div className="analysis-results-modal" onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div className="analysis-results-header">
          <div>
            <h2 className="analysis-results-title">Analysis Results</h2>
            <p className="analysis-results-university">{analysis.university_name}</p>
          </div>
          <button className="analysis-results-close" onClick={onClose}>
            <X size={24} />
          </button>
        </div>

        {/* Admission Chance */}
        <div className="analysis-results-chance">
          <div className="chance-circle" style={{ borderColor: getCategoryColor(analysis.category || analysis.analysis_category) }}>
            <span className="chance-percentage">{analysis.admit_chance_percentage}%</span>
            <span className="chance-label">Admission Chance</span>
          </div>
          <div className="chance-category" style={{ color: getCategoryColor(analysis.category || analysis.analysis_category) }}>
            {getCategoryLabel(analysis.category || analysis.analysis_category)} School
          </div>
        </div>

        {/* Summary */}
        {analysis.analysis_summary && (
          <div className="analysis-results-section">
            <div className="section-header">
              <TrendingUp size={20} />
              <h3>Summary</h3>
            </div>
            <p className="section-text">{analysis.analysis_summary}</p>
          </div>
        )}

        {/* Strengths */}
        {analysis.strengths && analysis.strengths.length > 0 && (
          <div className="analysis-results-section">
            <div className="section-header">
              <CheckCircle2 size={20} className="text-success" />
              <h3>Your Strengths</h3>
            </div>
            <ul className="section-list">
              {analysis.strengths.map((strength, idx) => (
                <li key={idx} className="list-item list-item-success">
                  {strength}
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Areas to Improve */}
        {analysis.areas_to_improve && analysis.areas_to_improve.length > 0 && (
          <div className="analysis-results-section">
            <div className="section-header">
              <AlertCircle size={20} className="text-warning" />
              <h3>Areas to Improve</h3>
            </div>
            <ul className="section-list">
              {analysis.areas_to_improve.map((area, idx) => (
                <li key={idx} className="list-item list-item-warning">
                  {area}
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Matching Factors */}
        {analysis.matching_factors && analysis.matching_factors.length > 0 && (
          <div className="analysis-results-section">
            <div className="section-header">
              <Target size={20} className="text-primary" />
              <h3>Why This Match Works</h3>
            </div>
            <ul className="section-list">
              {analysis.matching_factors.map((factor, idx) => (
                <li key={idx} className="list-item list-item-primary">
                  {factor}
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Action Plan */}
        {analysis.action_plan && analysis.action_plan.length > 0 && (
          <div className="analysis-results-section">
            <div className="section-header">
              <Lightbulb size={20} className="text-info" />
              <h3>Recommended Actions</h3>
            </div>
            <ul className="section-list">
              {analysis.action_plan.map((action, idx) => (
                <li key={idx} className="list-item list-item-info">
                  {action}
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Footer */}
        <div className="analysis-results-footer">
          <Button onClick={onClose} className="w-full">
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AnalysisResultsModal;
